// public/service-worker.js를 등록한다. PWA 설치 가능성(installability)
// 조건 중 하나가 "등록된 서비스 워커"라, 이게 없으면 브라우저가
// beforeinstallprompt 자체를 안 쏴서 로고 클릭 설치 버튼이 계속
// 아무 반응이 없었다(useInstallPrompt.js 참고).
export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js').catch((error) => {
        console.error('서비스 워커 등록 실패:', error);
      });
    });
  }
}
